import axios from 'axios';
import AuthResponse from '@/models/AuthResponse';
import Settings from '@/config/Settings';
import AuthController from '@/controllers/AuthController';
import UserResponse from '@/models/UserResponse';
import Response from '@/models/Response';

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common = { 'Content-Type': 'application/json' };

export default class UserController {
  private static readonly baseUrl = Settings.idUrl + `/api/users/`;

  public static async changePassword(
    accessToken: string,
    password: string,
    newpassword: string,
    refreshing = false
  ): Promise<UserResponse> {
    return await axios
      .patch(
        `${this.baseUrl}changepassword`,
        `{
              "oldPassword": "${encodeURIComponent(password)}",
              "newPassword": "${encodeURIComponent(newpassword)}"
             }`,
        { headers: { Authorization: accessToken } }
      )
      .then((response) => {
        if (response.status === 200) {
          return UserResponse.buildSuccesResponse(accessToken, `Password was updated.`, `Wachtwoord is aangepast.`);
        } else {
          return UserResponse.buildFailedResponse(
            `Expected status 200 but got ${response.status}`,
            `Verwachte status is 200, maar ontvangen status is ${response.status}`
          );
        }
      })
      .catch(async () => {
        if (!refreshing) {
          const response = await AuthController.refresh();
          if (response && !(response instanceof Response)) {
            const data = response.data as Record<string, string>;
            return await UserController.changePassword(data.access_token, password, newpassword, true);
          }
          return response;
        } else {
          return UserResponse.buildFailedResponse(`Failed updating password`, `Wachtwoord aanpassen mislukt`);
        }
      });
  }

  public static async forgotPassword(emailaddress: string) {
    return await axios
      .post(`${this.baseUrl}forgotpassword?email=${encodeURIComponent(emailaddress)}`)
      .then((response) => {
        if (response.status === 200) {
          return AuthResponse.buildSuccesResponse(
            `If the supplied e-mail address is known, a mail with password reset instructions has been sent.`,
            `Als het opgegeven e-mailadres bekend is, is er een mail met instructies om het wachtwoord te herstellen verstuurd.`
          );
        } else {
          return AuthResponse.buildFailedResponse(
            `Expected status 200 but got ${response.status}`,
            `Verwachte status is 200, maar ontvangen status is ${response.status}`
          );
        }
      });
  }

  public static async resetPassword(email: string, code: string, newpassword: string) {
    return await axios
      .post(
        `${this.baseUrl}resetpassword`,
        `{
                "email": "${email}",
                "resetCode": "${code}",
                "newPassword": "${encodeURIComponent(newpassword)}"
              }`
      )
      .then((response) => {
        if (response.status === 200) {
          return AuthResponse.buildSuccesResponse('Password was updated', 'Wachtwoord is aangepast');
        } else {
          return AuthResponse.buildFailedResponse(
            `Expected status 200 but got ${response.status}`,
            `Verwachte status is 200, maar ontvangen status is ${response.status}`
          );
        }
      })
      .catch(() => {
        return AuthResponse.buildFailedResponse(`Password was not updated`, `Wachtwoord is niet aangepast`);
      });
  }
}
